const API_BASE = process.env.REACT_APP_API_BASE || '';

export function getToken() {
  try { return localStorage.getItem('wp_token') || ''; } catch { return ''; }
}

export function setSession({ token, user }) {
  try {
    localStorage.setItem('wp_token', token);
    localStorage.setItem('wp_user', JSON.stringify(user));
  } catch {}
}

export function clearSession() {
  try {
    localStorage.removeItem('wp_token');
    localStorage.removeItem('wp_user');
  } catch {}
}

export function getUser() {
  try {
    const raw = localStorage.getItem('wp_user');
    return raw ? JSON.parse(raw) : null;
  } catch {
    return null;
  }
}

async function req(path, { method='GET', body, token } = {}) {
  const headers = { 'Content-Type': 'application/json' };
  const t = token ?? getToken();
  if (t) headers.Authorization = `Bearer ${t}`;
  const r = await fetch(`${API_BASE}${path}`, {
    method,
    headers,
    body: body ? JSON.stringify(body) : undefined,
  });
  const ct = r.headers.get('content-type') || '';
  const data = ct.includes('application/json') ? await r.json() : await r.text();
  if (!r.ok) {
    const err = typeof data === 'object' && data ? (data.error || 'request_failed') : 'request_failed';
    const e = new Error(err);
    e.status = r.status;
    e.data = data;
    throw e;
  }
  return data;
}

export const api = {
  login: (username, password) => req('/api/auth/login', { method: 'POST', body: { username, password } }),

  health: () => req('/api/health'),

  listValuadores: () => req('/api/valuadores'),
  createValuador: (name) => req('/api/valuadores', { method: 'POST', body: { name } }),

  listCatalogo: () => req('/api/catalogo'),
  listBankAccounts: (scope) => req(`/api/cuentas_banco${scope ? `?scope=${encodeURIComponent(scope)}` : ''}`),


  createBankAccount: (payload) => req('/api/cuentas_banco', { method: 'POST', body: payload }),
  getValuadorCuentas: (id) => req(`/api/valuadores/${id}/cuentas`),
  setValuadorCuentas: (id, payload) => req(`/api/valuadores/${id}/cuentas`, { method: 'PUT', body: payload }),

  listExpenses: (params={}) => {
    const q = new URLSearchParams(params).toString();
    return req(`/api/expenses${q ? `?${q}` : ''}`);
  },
  createExpense: (scope, payload) => req(`/api/expenses/${scope}`, { method: 'POST', body: payload }),
  updateExpense: (scope, id, patch) => req(`/api/expenses/${scope}/${id}`, { method: 'PATCH', body: patch }),
  decideExpense: (scope, id, status) => req(`/api/expenses/${scope}/${id}/decision`, { method: 'POST', body: { status } }),
  setPaidAmount: (scope, id, paid_amount) => req(`/api/expenses/${scope}/${id}/pago_parcial`, { method: 'POST', body: { paid_amount } }),
  rollover: (scope, id, target_day) => req(`/api/expenses/${scope}/${id}/rollover`, { method: 'POST', body: { target_day } }),

  // admin
  listUsers: () => req('/api/users'),
  createUser: (u) => req('/api/users', { method: 'POST', body: u }),
  resetPassword: (id, password) => req(`/api/users/${id}/reset_password`, { method: 'POST', body: { password } }),
};
